module.exports = __webpack_public_path__ + "img/meeting_video.b3ab5746.png";